export default "__VITE_ASSET__mdKjFGPm__"